import { h, Component } from 'preact'
import PoliticianListIntro from './PoliticianListIntro'
import PoliticianListFilter from './PoliticianListFilter'
import PoliticianList from './PoliticianList'
import { colors } from '../../constants'
import Page from '../Page'
import Header from '../layout/Header'

const defaultState = {
  type: '',
  party: '',
  region: '',
  name: '',
}

const Separator = () => (
  <div>
    <div
      style={{
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#fff',
        padding: 10,
        color: colors.middleGrey,
      }}
    >
      Senátoři
    </div>
    <div
      style={{ width: '100%', height: 1, backgroundColor: colors.middleGrey }}
    />
  </div>
)

const fullname = name => `${name.firstname} ${name.surname}`

const hideIf = fnc => p => (fnc(p) ? { ...p, hidden: true } : p)

const shouldBeDisplayed = (state, p) => {
  if (state.type && p.person.type !== state.type) return false
  if (state.party && p.person.party !== state.party) return false
  if (state.region && !p.person.regions.includes(state.region)) return false
  if (
    state.name &&
    !new RegExp(state.name.toLowerCase()).exec(
      fullname(p.person.name).toLowerCase(),
    )
  )
    return false
  return true
}

const mapHidden = (state, list) =>
  list.map(hideIf(p => !shouldBeDisplayed(state, p)))
const filterHidden = (state, list) =>
  list.filter(p => shouldBeDisplayed(state, p))

/* global window, $ */

const toQueryString = obj =>
  Object.keys(obj)
    .filter(key => obj[key])
    .map(key => `${key}=${obj[key]}`)
    .reduce((a, b) => (a ? `${a}&${b}` : b), '')
const fromQueryString = str => {
  const ret = {}
  decodeURIComponent(str)
    .split('&')
    .map(s => s.split('='))
    .forEach(([key, value]) => {
      ret[key] = value
    })
  return ret
}

class PoliticianListPage extends Component {
  constructor(props) {
    super(props)
    this.state = defaultState
    this.parties = this.props.list
      .map(p => p.person.party)
      .filter((value, index, self) => self.indexOf(value) === index)
    this.setFilter = key => val => {
      console.log('setFilter', key, val)
      let state
      if (key === 'name') {
        state = {
          ...defaultState,
          name: val,
        }
      } else {
        state = { ...this.state, [key]: val, name: '' }
      }
      this.setState(state)
      if (typeof window !== 'undefined' && window.history) {
        const url = `${window.location.protocol}//${window.location
          .host}${window.location.pathname}?${toQueryString(state)}`
        window.history.replaceState(state, $('title').text(), url)
      }
    }
  }
  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState(
      (window.history && window.history.state) || {
        ...defaultState,
        ...fromQueryString(window.location.href.split('?')[1]),
      },
    )
  }
  render() {
    console.log('Rendering PoliticianListPage')
    const list = mapHidden(this.state, this.props.list)

    const surnamesorter = (a, b) =>
      a.person.name.surname.localeCompare(b.person.name.surname)

    const listMOP = list
      .filter(p => p.person.type === 'MOP')
      .sort(surnamesorter)
    const listSenate = list
      .filter(p => p.person.type !== 'MOP')
      .sort(surnamesorter)

    const hasMOP = listMOP.some(p => !p.hidden)
    const hasSenator = listSenate.some(p => !p.hidden)
    return (
      <Page hostname={this.props.hostname}>
        <Header />
        <div style={{ minWidth: 512 }}>
          <PoliticianListIntro />
          <PoliticianListFilter
            setFilter={this.setFilter}
            filters={this.state}
            list={this.props.list}
            filterFunc={filterHidden}
            parties={this.parties}
          />
          {hasMOP ? (
            <PoliticianList list={listMOP} parties={this.props.parties} />
          ) : null}
          {hasMOP && hasSenator ? <Separator /> : null}
          {hasSenator ? (
            <PoliticianList list={listSenate} parties={this.props.parties} />
          ) : null}
          {!hasMOP && !hasSenator ? (
            <PoliticianList list={[]} parties={this.props.parties} />
          ) : null}
        </div>
      </Page>
    )
  }
}

export default PoliticianListPage



// WEBPACK FOOTER //
// ./components/PoliticianList/PoliticianListPage.js